import React, { useState } from "react";
import SlideMenu from "./SlideMenu";
import FormatAlignRight from "@material-ui/icons/FormatAlignRight";
import { connect } from "react-redux";
import { changeLocale } from "../../containers/LanguageProvider/actions";
import { createSelector } from "reselect";
import { makeSelectLocale } from "../../containers/LanguageProvider/selectors";
import cookie from "react-cookies";

const Header = React.memo(({ brandName, menudata, locale, changeLocale }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const logo = menudata?.QrmenuLogo?.ImageUrl;

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLanguageChange = (lang) => {
    if (locale !== lang) {
      cookie.save("Lang", lang, { path: "/" });
      changeLocale(lang);

      setTimeout(() => {
        window.location.hash = "#lang=" + lang;
        window.location.hash = "";
      }, 50);
    }
  };

  return (
    <>
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
          position: "relative",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {locale === "tr" ? (
            <img
              src={"/images/lang/en-EN.png"}
              style={{
                height: "3.0rem",
                cursor: "pointer",
                transition: "opacity 0.2s ease",
              }}
              onClick={() => handleLanguageChange("en")}
              alt="Switch to English"
              title="Switch to English"
            />
          ) : (
            <img
              src={"/images/lang/tr-TR.png"}
              style={{
                height: "3.0rem",
                cursor: "pointer",
                transition: "opacity 0.2s ease",
              }}
              onClick={() => handleLanguageChange("tr")}
              alt="Türkçe'ye Geç"
              title="Türkçe'ye Geç"
            />
          )}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
          }}
        >
          {logo && (
            <img
              src={logo}
              alt={brandName || "Logo"}
              style={{ height: "4.0rem" }}
              onError={(e) => {
                console.log("Image load error:", e);
                e.target.style.display = "none";
              }}
            />
          )}
        </div>

        <button
          onClick={toggleMenu}
          style={{
            background: "#fff",
            border: "none",
            padding: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            boxShadow: "0 0 11px 0 rgba(0, 0, 0, 0.05)",
            borderRadius: "4px",
            width: "50px",
            height: "50px",
            justifyContent: "center",
          }}
        >
          <FormatAlignRight />
        </button>
      </header>

      <SlideMenu
        menudata={menudata}
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
      />
    </>
  );
});

const mapStateToProps = createSelector(makeSelectLocale(), (locale) => ({
  locale,
}));

const mapDispatchToProps = {
  changeLocale,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);
